<template>
    <div style="display: flex; flex-direction: column; overflow:auto; flex-grow: 1; max-height: 100vh" v-loading="loading">
        <div class="t2t-inner-box" style="font-size: 1.5em; display: flex; justify-content: space-between">
            <div>
                Fullfillment Request
            </div>
            <div>
                <btn cssClass="btn btn-dark" :click="newFulfillment" icon="fas fa-plus">New Request</btn>
            </div>
        </div>

        <div class="ui-inner-box" style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: start">
                <div>
                    <div class="filter-label">Requested For:</div>
                    <el-select 
                        v-model="search.filters.requested_for" 
                        clearable 
                        filterable 
                        multiple 
                        placeholder="Select a month"
                    >
                        <el-option
                            v-for="(option) in lists.requested_for"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="ml-4">
                    <div class="filter-label">Requested By:</div>
                    <el-select 
                        v-model="search.filters.user_id" 
                        clearable 
                        filterable 
                        placeholder="Select a user"
                    >
                        <el-option
                            v-for="(option) in lists.users"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="ml-4">
                    <div class="filter-label">Employer:</div>
                    <el-select 
                        v-model="search.filters.employer_id" 
                        clearable 
                        filterable 
                        placeholder="Select an employer"
                    >
                        <el-option
                            v-for="(option) in lists.employers"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="ml-4" style="width: 225px">
                    <div class="filter-label">Subscription:</div>
                    <el-select 
                        v-model="search.filters.subscriptions" 
                        clearable 
                        filterable 
                        multiple 
                        placeholder="Select a subscription"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="(option) in lists.subscriptions"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="ml-4" style="width: 225px">
                    <div class="filter-label">Order type:</div>
                    <el-select 
                        v-model="search.filters.order_types" 
                        clearable 
                        filterable 
                        multiple 
                        placeholder="Select an order type"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="(option) in lists.order_types"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="ml-4">
                    <div class="filter-label">Pacing:</div>
                    <el-select 
                        v-model="search.filters.pacings" 
                        clearable 
                        filterable 
                        multiple 
                        placeholder="Select a pacing"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="(option) in lists.pacings"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="ml-4" style="width: 300px">
                    <div class="filter-label">Status:</div>
                    <el-select 
                        v-model="search.filters.statuses" 
                        clearable 
                        filterable 
                        multiple 
                        placeholder="Select a status"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="(option) in lists.statuses"
                            :key="option.id"
                            :label="option.name"
                            :value="option.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="mx-4 mt-4">
                    <btn cssClass="btn btn-dark" :click="filter" icon="fas fa-filter">Filter</btn>
                </div>  
            </div>

            <div class="mt-4">
                <btn cssClass="btn btn-dark" :click="exportStats" icon="fas fa-download">Export to CSV</btn>
            </div> 


            <!-- <div class="d-flex align-items-start">
                <span class="pt-1 mr-3">Show:</span>
                <el-checkbox v-model="search.filters.suggestions" @change="fetchCampaigns()" border size="medium">Suggestions</el-checkbox>
                <el-checkbox v-model="search.filters.draft" @change="fetchCampaigns()" border size="medium">Draft</el-checkbox>
                <el-checkbox v-model="search.filters.scheduled" @change="fetchCampaigns()" border size="medium">Scheduled</el-checkbox>
                <el-checkbox v-model="search.filters.sent" @change="fetchCampaigns()" border size="medium">Sent</el-checkbox>
                <el-checkbox v-model="search.filters.archived" @change="fetchCampaigns()" border size="medium">Archived</el-checkbox>
            </div>

            <div v-if="pagination.totalRecords">
                {{ `${pagination.startRecords} - ${pagination.endRecords} of ${pagination.totalRecords}` }}
                <div class="btn-group ">
                    <button type="button" class="btn btn-primary btn-sm" @click="prev()" :disabled="pagination.currentPage <= 1">«</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="next()" :disabled="pagination.currentPage >= pagination.lastPage">»</button>
                </div>
            </div> -->
        </div>

        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <sorting-header column="created_at" :sort="search.orderBy.column" :direction="search.orderBy.direction" @sorted="sorted">
                            Requested At
                        </sorting-header>
                        <sorting-header column="requested_for" :sort="search.orderBy.column" :direction="search.orderBy.direction" @sorted="sorted">
                            Requested For
                        </sorting-header>
                        <sorting-header column="user_name" :sort="search.orderBy.column" :direction="search.orderBy.direction" @sorted="sorted">
                            Requested By
                        </sorting-header>
                        <sorting-header column="employer_name" :sort="search.orderBy.column" :direction="search.orderBy.direction" @sorted="sorted">
                            Employer
                        </sorting-header>
                        <th>Campaign/Job</th>
                        <sorting-header column="order_type" :sort="search.orderBy.column" :direction="search.orderBy.direction" @sorted="sorted">
                            Order type
                        </sorting-header>
                        <sorting-header column="leads_ordered" :sort="search.orderBy.column" :direction="search.orderBy.direction" css-class="tb-la" @sorted="sorted">
                            # ordered
                        </sorting-header>
                        <sorting-header column="leads_delivered" :sort="search.orderBy.column" :direction="search.orderBy.direction" css-class="tb-la" @sorted="sorted">
                            # delivered
                        </sorting-header>
                        <sorting-header column="leads_needed" :sort="search.orderBy.column" :direction="search.orderBy.direction" css-class="tb-la" @sorted="sorted">
                            # still needed
                        </sorting-header>
                        <sorting-header column="daily_app_goal" :sort="search.orderBy.column" :direction="search.orderBy.direction" css-class="tb-la" @sorted="sorted">
                            Day cap
                        </sorting-header>
                        <sorting-header column="status" :sort="search.orderBy.column" :direction="search.orderBy.direction" @sorted="sorted">
                            Status
                        </sorting-header>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr :row="f" v-for="f in fulfillment_requests" :key="f.id" @changed="refresh">
                        <td>{{ f.created_at_formatted }}</td>
                        <td>{{ f.requested_for_formatted }}</td>
                        <td>{{ f.user_name }}</td>
                        <td><a :href="url(`admin/employer/${f.employer_id}/budgets`)">{{ f.employer_name }}</a></td>
                        <td>
                            {{ f.campaign_name }}<span v-if="f.job_id">, job <a :href="url(`admin/jobs/${f.job_id}`)">{{ f.job_id }}</a></span>
                        </td>
                        <td>{{ f.order_type }}</td>
                        <td class="tb-la">{{ f.leads_ordered }}</td>
                        <td class="tb-la">{{ f.leads_delivered }}</td>
                        <td class="tb-la">{{ f.leads_needed }}</td>
                        <td class="tb-la">{{ f.daily_app_goal }}</td>
                        <td>{{ f.status_text }}</td>
                        <td>
                            <a :href="url(`/admin/driver-engage/fulfillment/${f.id}`)">Detail</a>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th colspan="6">Total</th>
                        <th class="tb-la">{{ usNum(fulfillment_sums.leads_ordered_total) }}</th>
                        <th class="tb-la">{{ usNum(fulfillment_sums.leads_delivered_total) }}</th>
                        <th class="tb-la">{{ usNum(fulfillment_sums.leads_needed_total) }}</th>
                        <th class="tb-la">{{ usNum(fulfillment_sums.daily_app_goal_total) }}</th>
                        <th></th>
                        <th></th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
        ],
        components: {
        },
        data() {
            return {
                loading: true,
                fulfillment_requests: [],
                fulfillment_sums: [],
                lists: {
                    requested_for: [],
                    users: [],
                    employers: [],
                    subscriptions: [],
                    statuses: [],
                    order_types: [],
                    pacings: [],
                },
                search: {
                    page: 1,
                    filters: {
                        requested_for: [moment().format("YYYY-MM"), moment().add(1, "months").format("YYYY-MM")],
                        user_id: null,
                        employer_id: null,
                        subscriptions: [],
                        statuses: ["new", "unscheduled", "running-ja", "paused"],
                        order_types: [],
                        pacings: [],
                    },
                    orderBy: {
                        column: "created_at",
                        direction: "desc",
                    }
                },
                pagination: {
                    currentPage: 1,
                    lastPage: null,
                    startRecords: null,
                    endRecords: null,
                    totalRecords: null,
                    perPage: null,
                },
            }
        },
        watch: {
        },
        computed: {
        },
        methods: {
            refresh() {
                this.loading = true;

                return axios.post(url(`de/fulfillment/list`), this.search)
                    .then((response) => {
                        this.fulfillment_requests = response.data.fulfillment_requests;
                        this.fulfillment_sums = response.data.fulfillment_sums;
                        this.lists = response.data.lists;
                        this.loading = false;
                    })
            },
            newFulfillment() {
                this.$router.push({path: `/admin/driver-engage/fulfillment/new`});
            },
            filter() {
                this.refresh();

                // todo: pagination
            },
            sorted(sorted) {
                this.search.orderBy.column = sorted.col;
                this.search.orderBy.direction = sorted.dir;

                this.refresh();
            },
            exportStats() {
                let queryString = Object.keys(this.search.filters).map((key) => {
                    let part = key + '=';
                    if(this.search.filters[key] && Array.isArray(this.search.filters[key])) {
                        part += this.search.filters[key].join(",");
                    } else if(this.search.filters[key]) {
                        part += this.search.filters[key];
                    }

                    part += "&column=" + this.search.orderBy.column;
                    part += "&direction=" + this.search.orderBy.direction;

                    return part;
                }).join('&');

                window.location.href = url(`de/fulfillment/list/csv?${queryString}`);
            },
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style scoped>
    div.filter-label {
        font-size: 14px;
        margin-bottom: 4px;
        text-align: left;
    }
</style>